import React from "react";

function EmpowerMLM() {
  return (
    <>
      <div className="container p-5">
        <div
          className="pricing-style-one-item-cos bg-dark text-light"
          style={{
            backgroundImage:
              "url(https://validthemes.net/site-template/robok/assets/img/shape/10.png)",
          }}
        >
          <div className="text-center">
            <h3>Empower Your MLM Business with Xeer Technology</h3>
            <div className="bottom">
              <div className="pricing">
                <p>
                  With Xeer Technology’s MLM Development & Services, you can
                  bring your vision of a powerful network marketing platform to
                  life. We’re here to deliver a secure, scalable, and engaging
                  platform that adapts to your evolving business needs and
                  fosters growth across your network.
                </p>
              </div>
              <a className="btn btn-style-one mt-30" href="#">
                Get Started
              </a>
            </div>
          </div>
          {/* <div className="right-info"></div> */}
        </div>
      </div>
    </>
  );
}

export default EmpowerMLM;
